export { default as Img200 } from './processed/200/Ramy-Youssef.jpg';
export { default as Img400 } from './processed/400/Ramy-Youssef.jpg';
export { default as Imgthumb } from './processed/thumb/Ramy-Youssef.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Ramy-Youssef.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Ramy-Youssef.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      236,
      28,
      36
    ],
    "_population": 24378,
    "_hsl": [
      0.9935897435897436,
      0.8455284552845529,
      0.5176470588235295
    ]
  },
  "LightVibrant": {
    "_rgb": [
      214,
      67,
      75
    ],
    "_population": 13,
    "_hsl": [
      0.9909297052154195,
      0.6419213973799127,
      0.5509803921568628
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      183,
      43,
      50
    ],
    "_population": 70,
    "_hsl": [
      0.9916666666666667,
      0.6194690265486726,
      0.44313725490196076
    ]
  },
  "Muted": {
    "_rgb": [
      130,
      115,
      116
    ],
    "_population": 529,
    "_hsl": [
      0.9888888888888889,
      0.06122448979591833,
      0.48039215686274506
    ]
  },
  "LightMuted": {
    "_rgb": [
      179,
      179,
      179
    ],
    "_population": 1147,
    "_hsl": [
      0,
      0,
      0.7019607843137254
    ]
  },
  "DarkMuted": {
    "_rgb": [
      68,
      66,
      67
    ],
    "_population": 459,
    "_hsl": [
      0.9166666666666666,
      0.014925373134328304,
      0.2627450980392157
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Ramy-Youssef.js